module.exports = __webpack_public_path__ + "static/media/insight6.3ee29b17.png";